import { Box, Modal, ModalProps } from '@mui/material';

type ControlledModaldProps = {
    children: React.ReactNode;
    handleClose?: () => void;
} & ModalProps;

export default function ModalBase({ handleClose, children, ...rest }: ControlledModaldProps) {
    return (
        <Modal
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            {...rest}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: '8px',
                    boxShadow: 24,
                    p: 4,
                    width: '80%',
                    maxWidth: 1000,
                    '&:focus-visible': {
                        outline: 'none',
                    },
                }}
            >
                {children}
            </Box>
        </Modal>
    );
}
